"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecoveryModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _RecoveryModalModule = _interopRequireDefault(require("./RecoveryModal.module.css"));
var _excluded = ["onSuccess", "onCancel", "initialTab"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RecoveryModal = function RecoveryModal(_ref) {
  var onSuccess = _ref.onSuccess,
    onCancel = _ref.onCancel,
    initialTab = _ref.initialTab,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, _extends({
    contentClassName: _RecoveryModalModule.default.modal,
    onHide: onCancel
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: _RecoveryModalModule.default.body
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    defaultActiveKey: initialTab,
    className: _RecoveryModalModule.default.tabs
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "password",
    title: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    className: _RecoveryModalModule.default.form
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _RecoveryModalModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _RecoveryModalModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _RecoveryModalModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    className: _RecoveryModalModule.default.buttonsContainer,
    gap: 4
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: 'success',
    onClick: onSuccess
  }, "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: 'secondary',
    onClick: onCancel
  }, "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0")))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "username",
    title: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    className: _RecoveryModalModule.default.form
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _RecoveryModalModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _RecoveryModalModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    style: {
      justifyContent: 'flex-end'
    },
    gap: 4
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: 'success',
    onClick: onSuccess
  }, "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: 'secondary',
    onClick: onCancel
  }, "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0")))))));
};
exports.RecoveryModal = RecoveryModal;
RecoveryModal.propTypes = {
  show: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  initialTab: _propTypes.default.oneOf(['password', 'username']),
  onCancel: _propTypes.default.func,
  onSuccess: _propTypes.default.func
};
RecoveryModal.defaultProps = {
  show: true,
  centered: true,
  initialTab: 'password',
  onCancel: function onCancel() {
    return console.log("success");
  },
  onSuccess: function onSuccess() {
    return console.log("success");
  }
};